import '@fancyapps/fancybox';
import './jquery.serializejson';
import initCountProduct from './utils/customInputNumber';
import __Product from './riashop/product.js';
import initRelatedSlider from './components/related-slider';
import initColorPicker from './components/colorPicker';

(function (DOC, WIN) {
  var CORE = {
    // Gestion des adresses postal
    btnNewAddress: '[href="#add-new-adr"]',
    btnSaveAddress: '[name="save-new-address"]',
    btnDeleteAddress: '[href="#del-adr"]',

    // Gestion des choix d'adresse de livraison et/ou facturation
    btnChangeAdrDelivery: '[name="select-adr-delivery"]',
    btnChangeAdrInvoice: '[name="select-adr-invoice"]',

    // Gestion des options de livraison
    btnChangeService : '[name="dlv-srv"]',

    // Recherche de points relais
    btnSearchRelay: '[name="search-relay"]',
    btnChooseRelay: '[href="#rly-choose"]',

    // Gestion de l'édition d'une ligne de panier
    inputQty: '.cart-single-item__quantity .spinner',
    btnDeleteLine: '.delete-item',

    // Gestion des codes promotions
    btnPmtCodAdd: '.apply-pmt-cod',
    btnPmtCodDel: '.del-pmt-cod',

    // Paiement
    btnPayCart: '[name="payment"]',

    // Suject de contact
    selectSubject: '#subject',

    // Actualités (Pagination + choix tags)
    newsTagChecekbox: '.news-tag-checkbox',
    newsPaging: '.news-paging a',
    newsBtnValidTags: '.valid-news-tags',

    // Gestion des cookies
    cookiesBtnAccept: '.btn-cookies-accept',

    // Consulter en tant que
    timeoutViewAdmin: false,
    viewAdminInput: '[name="view-admin"]',

    // Inscription à la newslleter
    nlrInsciptButton: '[name="nlr-inscript"]',

    // Ouverture du moteur de recherche en mobile
    searchButtonOpen: '.icon-search',

    // Bouton radio du choix de paiement
    paymentOptions: '.payment-options [type="radio"]',

    timerUpdate: false,

    construct: function(){
      CORE.init();
      __Product.Minicart();
    },

    /** Cette fonction initialiser les différentes actions du module de gestion des adresses postales
     */
    init: function(){
      CORE.loadSheetChilds();
      CORE.loadLikeAlso();

      // Applique la remise selon le mode de paiement
      $( CORE.paymentOptions ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          $('.rf-ajax-load').show();

          $.ajax({
            method: 'POST',
            url: '/ajax/cart/',
            data: {
              changepaytype: 1,
              type: $(this).val(),
            }
          }).done(function(data){
            data = $.parseJSON( data );

            if( data.success == '1' ){
              CORE.reloadCartInfo( data );
            }

            jQuery('a.lightbox:not(.init), [data-fancybox]:not(.init)').each(function(){
              $(this).addClass('init');

              $(this).click(function(){
                if( $(this).data('fancybox') == 'gallery' ){
                  return;
                }

                var indexed_array = $(this).parents('form').serializeJSON();

                $.fancybox.open({
                  src: $(this).data('src'),
                  type: $(this).data('type'),
                  parentEl: 'body',
                  margin: [50, 0],
                  lang: 'fr',
                  i18n: {
                    fr: {
                      CLOSE: 'Fermer',
                      NEXT: 'Prochain',
                      PREV: 'Précédent',
                      ERROR: 'Le contenu demandé ne peut pas être chargé. <br/> Veuillez réessayer plus tard.',
                      PLAY_START: 'Lancer le diaporama',
                      PLAY_STOP: 'Suspendre le diaporama',
                      FULL_SCREEN: 'Plein écran',
                      THUMBS: 'Vignettes',
                      DOWNLOAD: 'Télécharger',
                      SHARE: 'Partager',
                      ZOOM: 'Zoom',
                    },
                  },
                  ajax: {
                    settings: {
                      data: indexed_array
                    }
                  }
                });
              });
            });

            $('.rf-ajax-load').hide();
          });
        });
      });

      // Clique sur l'ouverture de la recherche pour la version mobile
      $( CORE.searchButtonOpen ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          if( $('.search-panel .form-group').hasClass('active') ){
            $('.search-panel .form-group').removeClass('active');
          }else{
            $('.search-panel .form-group').addClass('active');
          }

          return false;
        });
      });

      // Clique sur l'ajout d'une nouvelle adresse
      $( CORE.btnNewAddress ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          CORE.editAddress( $(this) );
          return false;
        });
      });

      // Clique sur l'enregistrement d'une nouvelle adresse (popup d'ajout d'adresse)
      $( CORE.btnSaveAddress ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          CORE.saveAddress( $(this) );
          return false;
        });
      });

      // Clique sur la suppression d'une adresse (popup d'ajout d'adresse)
      $( CORE.btnDeleteAddress ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          CORE.deleteAddress( $(this) );
          return false;
        });
      });

      // Choix d'une autre adresse de livraison
      $( CORE.btnChangeAdrDelivery ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'change', function(){
          CORE.updateAddress( 'delivery', $(this).val() );
        });
      });

      // Choix d'une autre adresse de facturation
      $( CORE.btnChangeAdrInvoice ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'change', function(){
          CORE.updateAddress( 'invoice', $(this).val() );
        });
      });

      // Choix d'un service de livraison
      $( CORE.btnChangeService ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'change', function(){
          CORE.setDeliveryService( $(this).val() );
        });
      });

      // Clique sur le bouton de suppression d'une ligne du panier
      $( CORE.btnDeleteLine ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          if( $('[name="batch-cart"]').length ){
            CORE.deleteLineBatch( $(this) );
          }else{
            CORE.deleteLine( $(this) );
          }
          return false;
        });
      });

      // Changement d'une quantite d'une ligne du panier
      $( CORE.inputQty ).not('._init').each(function(){
        CORE.updateTotalBatch();

        $(this).addClass('_init');

        $(this).on( 'change', function(){
          if( $('[name="batch-cart"]').length ){
            CORE.updateLineBatch( $(this) );
          }else{
            CORE.updateLine( $(this) );
          }
          return false;
        });
      });

      // Clique sur le bouton payé
      $( CORE.btnPayCart ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          return CORE.pay();
        });
      });

      // Change de sujet dans le formulaire de contact
      $( CORE.selectSubject ).change(function(){
        CORE.changeSubject( $( CORE.selectSubject ).val() );
      });

      // Clique sur les premiers tags des actualités
      $( CORE.newsTagChecekbox ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'change', function(){
          CORE.reloadNews(1);
        });
      });

      // Clique sur la pagination des actualités
      $( CORE.newsPaging ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          var page = parseInt( $(this).attr('href').replace( '?page=', '' ) );
          if( isNaN(page) ){
            page = 1;
          }

          CORE.reloadNews( page );
          return false;
        });
      });

      // Clique sur la validation de tags pour les actualités
      $( CORE.newsBtnValidTags ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          CORE.reloadNews( 1 );
          return false;
        });
      });

      // Clique sur la validation des cookies
      $( CORE.cookiesBtnAccept ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          $.ajax({
            url: '/ajax/account.php',
            data: 'accept-ck=1',
            method: 'post'
          }).done(function(){
            $( CORE.cookiesBtnAccept ).parents('.cookies-panel').remove();
          });
        });
      });

      // Clique sur la recherche d'un point relai
      $( CORE.btnSearchRelay ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          CORE.searchRelay();
          return false;
        });
      });

      // Clique sur le choix d'un point relai
      $( CORE.btnChooseRelay ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          CORE.chooseRelay( $(this).data('code') );
          return false;
        });
      });

      // Clique sur le bouton d'ajout d'un code promotion
      $( CORE.btnPmtCodAdd ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          CORE.addPmtCod();
          return false;
        });
      });

      // Clique sur le bouton d'ajout d'un code promotion
      $( CORE.btnPmtCodDel ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          CORE.delPmtCod( $(this).data('id') );
          return false;
        });
      });

      // Recherche d'un compte via le Consulter en tant que
      $( CORE.viewAdminInput ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'keyup', function(){
          CORE.searchAccountForConsultAs( $(this) );
          return false;
        });
      });

      // Enregistre l'inscription à la newsletter
      $( CORE.nlrInsciptButton ).not('._init').each(function(){
        $(this).addClass('_init');

        $(this).on( 'click', function(){
          CORE.incriptionNewsletterInit( $(this) );
          return false;
        });
      });
    },

    incriptionNewsletterInit: function( element ){
      var data = element.parents('form').find('input').serializeJSON();
      data.nlrinscript = 'on';

      $.ajax({
        method: 'post',
        url: '/ajax/account.php', // (lang == 'en' ? '/en' : '') +
        data: data,
        dataType: 'json'
      }).done(function (data) {
        $('.form-news .error-block, .form-news success-block').remove();

        var htmlReturn = '';
        if (data.success == 1) {
          htmlReturn = '<div class="success-block __show">' + data.content.message + '</div>';
        }else if( data.success == 0 ){
          htmlReturn = '<div class="error-block __show">' + data.content + '</div>';
        }

        $('.form-news [name="email"]').before( htmlReturn );
      });

      return false;
    },

    searchAccountForConsultAs: function( element ){
      clearTimeout(CORE.timeoutViewAdmin);

			CORE.timeoutViewAdmin = setTimeout(function () {
				if ($.trim(element.val()) == '') {
					$('.view-admin-list').hide();
					return;
				}

				$.ajax({
					method: 'get',
					url: '/ajax/account.php', // (lang == 'en' ? '/en' : '') +
					data: {
						consultas: 1,
						sch: element.val()
					},
					dataType: 'json'
				}).done(function (data) {
					if (data.success == 1) {
						$('.ajax-view-admin-list').html(data.content.account);
						$('.view-admin-list').removeClass('hidden');
						$('.view-admin-list .icon-close').removeClass('hidden');
					}
				});
			}, 300);
    },

    loadLikeAlso: function(){
      // Chargement ajax de la zone "Vous aimerez également" sur la fiche produit
      if( $('.ajax-also-like').length ){
        let ajaxPrdID = $('.ajax-also-like').data('prd-id');

        $.ajax({
          url: '/ajax/catalog.php',
          data: 'action=load-like-also&prd=' + ajaxPrdID,
          method: 'get'
        }).done(function( result ){
          let data = $.parseJSON( result );

          if( data.success == '1' ){
            $('.ajax-also-like').html(data.content);
          }

          CORE.loadAlsoCategory();
          initRelatedSlider();
        });
      }
    },

    loadAlsoCategory: function(){
      // Chargement ajax de la zone "Vous aimerez également" sur la fiche produit
      if( $('.ajax-also-category').length ){
        let ajaxPrdID = $('.ajax-also-category').data('prd-id');

        $.ajax({
          url: '/ajax/catalog.php',
          data: 'action=load-also-category&prd=' + ajaxPrdID,
          method: 'get'
        }).done(function( result ){
          let data = $.parseJSON( result );

          if( data.success == '1' ){
            $('.ajax-also-category').html(data.content);
          }

          CORE.loadHistoryPrd();
          initRelatedSlider();
        });
      }
    },

    loadHistoryPrd: function(){
      // Chargement ajax de la zone "Vous aimerez également" sur la fiche produit
      if( $('.ajax-history-prd').length ){
        let ajaxPrdID = $('.ajax-history-prd').data('prd-id');

        $.ajax({
          url: '/ajax/catalog.php',
          data: 'action=load-history-prd&prd=' + ajaxPrdID,
          method: 'get'
        }).done(function( result ){
          let data = $.parseJSON( result );

          if( data.success == '1' ){
            $('.ajax-history-prd').html(data.content);
          }

          if( document.getElementsByClassName('countdown').length ){
            var clockdiv = document.getElementsByClassName("countdown");

            var countDownDate = new Array();
            for (var i = 0; i < clockdiv.length; i++) {
              countDownDate[i] = new Array();
              countDownDate[i]['el'] = clockdiv[i];
              countDownDate[i]['time'] = new Date(clockdiv[i].getAttribute('data-date')).getTime();
              countDownDate[i]['days'] = 0;
              countDownDate[i]['hours'] = 0;
              countDownDate[i]['seconds'] = 0;
              countDownDate[i]['minutes'] = 0;
            }

            setInterval(function() {
              for (var i = 0; i < countDownDate.length; i++) {
                var now = new Date().getTime();
                var distance = countDownDate[i]['time'] - now;

                countDownDate[i]['days'] = Math.floor(distance / (1000 * 60 * 60 * 24));
                countDownDate[i]['hours'] = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                countDownDate[i]['minutes'] = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                countDownDate[i]['seconds'] = Math.floor((distance % (1000 * 60)) / 1000);

                if (distance < 0) {
                  countDownDate[i]['el'].querySelector('.timer').innerHTML = 'Fin';
                }else{
                  countDownDate[i]['el'].querySelector('.timer').innerHTML = countDownDate[i]['days'] + ' J ' + countDownDate[i]['hours'] + ' H ' + countDownDate[i]['minutes'] + ' M ' + countDownDate[i]['seconds'] + ' S';
                }
              }
            }, 1000);
          }

          initRelatedSlider();
        });
      }
    },

    loadSheetChilds: function(){
      // Chargement ajax de la zone "Choix des articles enfants" sur la fiche produit
      if( $('.ajax-sheet-childs').length ){
        let ajaxPrdID = $('.ajax-sheet-childs').data('prd-id');

        $.ajax({
          url: '/ajax/catalog.php',
          data: 'action=load-sheet-childs&prd=' + ajaxPrdID,
          method: 'get'
        }).done(function( result ){
          let data = $.parseJSON( result );

          if( data.success == '1' ){
            $('.ajax-sheet-childs').html(data.content.sheet);
            $('.ajax-colors').html(data.content.colors);
            $('.ajax-ptsclubs').html(data.content.ptsclubs);
            $('.ajax-catalogpage').html(data.content.catalogpage);

            if( typeof data.content.onestar != 'undefined' && data.content.onestar == '1' ){
              $('.img-prd-star').show();
            }

            initColorPicker();
            initCountProduct();

            var product = DOC.getElementsByClassName( 'product-form' );
            var i = 0;

            if (typeof product !== 'object' || product == null || !product.length) {
              return;
            }
            this.product = [];

            for (i; i < product.length; i++) {
              this.product[this.product.length] = product[i];

              // Une classe "__init" est ajouté à l'élement pour éviter de reconstruire les events JS dessus une seconde fois
              // Sans cela, la popup d'ajout au panier s'affichera plusieurs fois si l'on clique sur deux boutons d'ajout au panier dans
              // le listing produit
              if( !$( product[i] ).hasClass('__init') ){
                $( product[i] ).addClass('__init');
                __Product.Product($('body'), product[i]);
              }
            }

            jQuery('a.lightbox:not(.init), [data-fancybox]:not(.init)').each(function(){
              $(this).addClass('init');

              $(this).click(function(){
                if( $(this).data('fancybox') == 'gallery' ){
                  return;
                }

                var indexed_array = $(this).parents('form').serializeJSON();

                $.fancybox.open({
                  src: $(this).data('src'),
                  type: $(this).data('type'),
                  parentEl: 'body',
                  margin: [50, 0],
                  lang: 'fr',
                  i18n: {
                    fr: {
                      CLOSE: 'Fermer',
                      NEXT: 'Prochain',
                      PREV: 'Précédent',
                      ERROR: 'Le contenu demandé ne peut pas être chargé. <br/> Veuillez réessayer plus tard.',
                      PLAY_START: 'Lancer le diaporama',
                      PLAY_STOP: 'Suspendre le diaporama',
                      FULL_SCREEN: 'Plein écran',
                      THUMBS: 'Vignettes',
                      DOWNLOAD: 'Télécharger',
                      SHARE: 'Partager',
                      ZOOM: 'Zoom',
                    },
                  },
                  ajax: {
                    settings: {
                      data: indexed_array
                    }
                  }
                });
              });
            });
          }
        });
      }
    },

    addPmtCod: function(){
      var cod = $('[id="promo"]').val();
      if( $.trim(cod) != '' ){
        $('.rf-ajax-load').show();

        $.ajax({
          method: 'POST',
          url: '/ajax/cart/',
          data: {
            applypmtcode: 1,
            cod: cod,
          }
        }).done(function(data){
          data = $.parseJSON( data );

          if( data.success == '1' ){
            CORE.reloadCartInfo( data );
          }else{
            $('.promo-input').after('<div class="form-notes error mb-2">' + data.content + '</div>');
          }

          $('.rf-ajax-load').hide();
        });
      }
    },

    delPmtCod: function( id ){
      if( $.trim(id) != '' ){
        $('.rf-ajax-load').show();

        $.ajax({
          method: 'POST',
          url: '/ajax/cart/',
          data: {
            delpmtcode: 1,
            id: id,
          }
        }).done(function(data){
          data = $.parseJSON( data );

          if( data.success == '1' ){
            CORE.reloadCartInfo( data );
          }

          $('.rf-ajax-load').hide();
        });
      }
    },

    /** Cette fonction permet de sauvegarder le choix d'un point relai pour la livraison de la commande.
     * @param {string} rlyID Code du point relias
     */
    chooseRelay: function( rlyID ){
      $('.rf-ajax-load').show();

      $.ajax({
        method: 'POST',
        url: '/ajax/cart/',
        data: {
          updateRelay: 1,
          code: rlyID,
        }
      }).done(function(data){
        data = $.parseJSON( data );

        if( data.success == '1' ){
          CORE.reloadCartInfo( data );
        }

        $('.rf-ajax-load').hide();
      });
    },

    /** Cette fonction permet de lancer une recherche de points relais en fonction du code postal et de la ville saisis.
     */
    searchRelay: function(){
      $('.rf-ajax-load').show();

      var dataJSON = $('.form-search-relay').find('input').serializeJSON();
      dataJSON.searchrelay = 1;

      $.ajax({
        method: 'GET',
        url: '/ajax/relais/',
        data: dataJSON
      }).done(function(data){
        data = $.parseJSON( data );

        if( data.success == '1' ){
          $('.rf-cart-adr-data').html( data.content );
          CORE.init();
        }

        $('.rf-ajax-load').hide();
      });
    },


    /** Cette fonction permet de mettre à jour les actualités du blog
     * @param {int} page Obligatoire, numéro de la page à charger
     */
    reloadNews: function( page ){
      $('.rf-ajax-load').show();

      var dataJSON = $('.article-filter').find('input').serializeJSON();
      dataJSON.page = page;

      $.ajax({
        method: 'GET',
        url: '/blog/',
        data: dataJSON
      }).done(function(data){
        data = $.parseJSON( data );

        if( data.success == '1' ){
          $('.rf-news-list').html( data.content.news );
          $('.rf-news-paging').html( data.content.pagination );

          CORE.init();
        }

        $('.rf-ajax-load').hide();
      });
    },

    /** Cette fonction permet d'initialiser la popup d'ajout ou de mise à jour d'une adresse postale.
     *  @param {object} element Bouton "Créer une nouvelle adresse" ou "Modifier l'adresse" sur lequel on vient de cliquer
     */
    editAddress: function( element ){
      var oldpopup = $('.fancybox-container');
      var isInvoice = element.data('is-invoice');
      var adrID = parseInt( element.data('id') );
      if( isNaN(adrID) ){
        adrID = 0;
      }
      var adrbook = typeof element.data('adrbook') != 'undefined' ? element.data('adrbook') : 0;

      $('.edit-address-success').addClass('d-none');

      $.fancybox.open({
        src: '/ajax/cart.php',
        type: 'ajax',
        parentEl: 'body',
        margin: [50, 0],
        lang: 'fr',
        i18n: {
          fr: {
            CLOSE: 'Fermer',
            NEXT: 'Prochain',
            PREV: 'Précédent',
            ERROR: 'Le contenu demandé ne peut pas être chargé. <br/> Veuillez réessayer plus tard.',
            PLAY_START: 'Lancer le diaporama',
            PLAY_STOP: 'Suspendre le diaporama',
            FULL_SCREEN: 'Plein écran',
            THUMBS: 'Vignettes',
            DOWNLOAD: 'Télécharger',
            SHARE: 'Partager',
            ZOOM: 'Zoom',
          },
        },
        ajax: {
          settings: {
            data: {
              newaddress: 1,
              invoice: isInvoice,
              id: adrID,
              adrbook: adrbook
            },
            type: 'get'
          }
        },
        afterShow: function(){
          oldpopup.each(function(){
            $(this).remove();
          });

          CORE.init();
        }
      });
    },

    /** Cette fonction permet de sauvegarder les modification sur une adresse postale.
     *  @param {object} element Object sur lequel on vient de cliquer
     */
    saveAddress: function( element ){
      var oneError = false;

      var require = ['firstname', 'lastname', 'address1', 'zipcode', 'city', 'phone'];
      require.forEach(function(item, index, array){
        if( $.trim($('#' + item).val()) == '' ){
          $('#' + item).parent().addClass('input-error');
          oneError = true;
        }else{
          $('#' + item).parent().removeClass('input-error');
        }
      });

      if( oneError ){
        $('.input-error:first input').focus();
        $('.form-notes.error').html( $('.error-block p').html());
      }else{
        var dataJSON = element.parents('form').serializeJSON();

        $('.form-notes.error').html('');
        $('.rf-ajax-load').show();

        // Enregistre en base la nouvelle adresse
        $.ajax({
          method: 'POST',
          url: '/ajax/cart.php',
          data: dataJSON
        }).done(function(data){
          data = $.parseJSON( data );

          if( data.success == '0' ){
            $('.form-notes.error').html( data.content );
          }else{
            if (typeof dataJSON.adrbook != 'undefined' && dataJSON.adrbook) {
              window.location.href = '/mon-compte/carnet-adresses/';
              return false;
            }

            if( $('[name="upd-adr"]').length ){
              // Il s'agit d'une mise à jour d'adresse depuis l'espace Mon Compte > Mes adresses
              $('.edit-address-success').removeClass('d-none');
              $('.rf-card-address-' + dataJSON.adr_id).html( data.content.address );
            }

            CORE.reloadCartInfo( data );
            $.fancybox.close();
          }

          $('.rf-ajax-load').hide();
        });
      }
    },

    /** Cette fonction permet de supprimer une adresse postale
     * @param {object} element Lien "Supprimer" d'un encart d'adresse sur lequel l'internaute a cliqué
     */
    deleteAddress: function( element ){
      $('.rf-ajax-load').show();

      var adrID = parseInt( element.data('adr-id') );
      if( !isNaN(adrID) ){
        $.ajax({
          method: 'POST',
          url: '/ajax/cart.php',
          data: 'del-adr=1&id=' + adrID
        }).done(function(data){
          data = $.parseJSON( data );

          if( data.success == '0' ){
          }else{
            $('[data-adr-id="' + adrID + '"]').parents('.col-12').remove();
          }

          $('.rf-ajax-load').hide();
        });
      }
    },

    /** Cette fonction permet de mettre à jour l'adresse de livraison ou de facturation pour un le panier en cours
     *  @param {string} type Type d'adresse à mettre à jour delivery => adresse de livraison, invoice => adresse de facturation
     *  @param {int} id Identifiant de l'adresse à appliquer
     */
    updateAddress: function( type, id ){
      var action = 'upd-adr-delivery';

      if( type == 'invoice' ){
        action = 'upd-adr-invoice';
      }

      $('.rf-ajax-load').show();
      // Mise à jour de l'adresse de livraison ou de facturation
      $.ajax({
        method: 'POST',
        url: '/ajax/cart.php',
        data: action + '=1&adr=' + id
      }).done(function(data){
        data = $.parseJSON( data );

        if( data.success == '0' ){
        }else{
          CORE.reloadCartInfo( data );
          $.fancybox.close();
        }

        $('.rf-ajax-load').hide();
      });
    },

    /** Cette fonction permet de mettre à jour le choix du service de livraison fait par l'internaute
     *  @param {int} id Identifiant du service de livraison choisi
     */
    setDeliveryService: function( id ){
      $('.rf-ajax-load').show();

      // Mise à jour de l'adresse de livraison ou de facturation
      $.ajax({
        method: 'POST',
        url: '/ajax/cart.php',
        data: 'upd-srv=1&srv_id=' + id
      }).done(function(data){
        data = $.parseJSON( data );

        if( data.success == '0' ){
        }else{
          CORE.reloadCartInfo( data );
        }

        $('.rf-ajax-load').hide();
      });
    },

    /** Cette fonction permet de mettre à jour des éléments de l'interface suite à une mise à jour sur le panier
     * @param {json} data Données sous format JSON en retour Ajax d'un action réalisée sur le panier
     */
    reloadCartInfo: function( data ){
      if( data.content.minicart ){
        $('.cart-tool__drop').html( data.content.minicart );
      }

      if( data.content.summary ){
        $('.rf-cart-totals').html( data.content.summary );
      }

      if( data.content.delivery ){
        $('.rf-cart-adr-data').html( data.content.delivery );
      }

      if( data.content.cart ){
        $('.rf-cart-details').html( data.content.cart );
      }

      if( data.content.services ){
        $('.rf-cart-services').html( data.content.services );
      }

      // Recharge les actions sur de nouveaux éléments ayant pu être rajoutés
      CORE.init();
    },

    /** Cette fonction permet de déclencher le paiement du panier.
     *
     */
    pay: function(){
      $('.rf-ajax-load').show();

      var error = new Array();

      // Contrôle que les CGV sont bien coché
      if( !$('[name="check-cgv-payment"]').is(':checked') ){
        error.push('Veuillez accepter les conditions générales de ventes.');
      }

      var payID = parseInt( $('[name="paymode"]:checked').val() );
      if( isNaN(payID) ){
        error.push('Veuillez sélection un moyen de paiement');
      }

      $('.form-notes.error').html( error.join('<br />') );
      if( error.length > 0 ){
        $('.rf-ajax-load').hide();
      }

      if( error.length == 0 ){
        switch (payID) {
          case 241: // CB plusieurs fois
          case 1: // CB
            $.ajax({
              method: 'GET',
              url: '/ajax/cart/payment.php',
              data: {
                payid: payID
              }
            }).done(function(data){
              $('#form-payment-cb').html( data );
              $('#systempay').submit();
              $('.rf-ajax-load').hide();
            });
            return false;
          case 2: // Chèque
          case 3: // En compte
          // case 5: // PayPal
          case 7: // Prélèvement à 8 jours
          case 11: // Virement
            return true;
        }
      }

      return false;
    },

    /** Cette fonction permet de mettre à jour une ligne du panier lorsque la quantité est modifiée sur celle-ci.
     * @param {object} element Spinner pour lequel la quantité a changée
     */
    updateLine( element ){
      clearTimeout( CORE.timerUpdate );

      // Prépare les données pour la mise à jour de quantité
      var dataJSON = element.parent().find('input').serializeJSON();
      dataJSON.upd_line_cart = 1;

      CORE.timerUpdate = setTimeout(function(){
        $('.rf-ajax-load').show();

        $.ajax({
          method: 'post',
          url: '/ajax/cart.php',
          data: dataJSON
        }).done( function( data ){
          data = $.parseJSON( data );

          if( data.success == '0' ){
          }else{
            CORE.reloadCartInfo( data );
            initCountProduct();
          }

          $('.rf-ajax-load').hide();
        });
      }, 500);
    },

    /** Cette fonction permet de mettre à jour une ligne, dans le processus de commande rapide, lorsque la quantité est modifiée sur celle-ci.
     * @param {object} element Spinner pour lequel la quantité a changée
     */
     updateLineBatch( element ){
      let total = parseFloat( element.parents('.cart-single-item').find('.cart-single-item__price .price-holder').html().replace(',', '.').replace(' ', '') ) * element.val();
      total = total.toFixed( 2 );

      element.parents('.cart-single-item').find('.cart-single-item__total-price .price--total .price-holder').html( total.replace('.', ',') );

      CORE.updateTotalBatch();
      $('.rf-ajax-load').hide();
    },

    /** Cette fonction permet de supprimer une ligne du panier.
     *  @param {object} element Bouton supprimé sur lequel l'internaute a cliqué
     */
    deleteLine( element ) {
      $('.rf-ajax-load').show();

      var prdID = element.data('prd-id');
      var lineID = element.data('line-id');

      $.ajax({
        method: 'post',
        url: '/ajax/cart.php',
        data: 'del-line-cart=1&prd=' + prdID + '&line=' + lineID,
        dataType: 'json'
      }).done(function (data) {

        if (data.success == '0') {
          $('.rf-ajax-load').hide();
          return;

        }
        CORE.reloadCartInfo(data);
        initCountProduct();
        $('.rf-ajax-load').hide();

      });
    },

    /** Cette fonction permet de supprimer une ligne dans le processus de commande rapide.
     *  @param {object} element Bouton supprimé sur lequel l'internaute a cliqué
     */
     deleteLineBatch( element ) {
      element.parents('.cart-single-item').remove();
      CORE.updateTotalBatch();
    },

    changeSubject: function( subject ){
      // Affichage du champ de commande selon le suject choisi
      if( subject == 'Commande' || subject == 'Réclamation & retour' ){
        $('#div-zone-order').removeClass('d-none').addClass('d-md-flex');
      }else{
        $('#div-zone-order').addClass('d-none').removeClass('d-md-flex');
      }
    },

    updateTotalBatch: function(){
      let total = 0;

      $('.cart-single-item').each(function(){
        let qty = parseInt( $(this).find('.spinner').val() );
        let price = parseFloat( $(this).find('.cart-single-item__price .price-holder').html().replace(',', '.').replace(' ', '') );

        total += qty * price;
      });

      total = parseFloat( total );
      total = total.toFixed( 2 );

      $('.total-order-info .js-total-price').html( total.replace('.', ',') );
    }
  };

  CORE.construct();
})(document, window);


